export const loadState = () => {
  // Using try catch is essential as the user privacy mode
  // may not allow the use of localstoarge
  try {
    const serializedState = localStorage.getItem("state");
    if (serializedState === null) {
      // key doesn't exist, reducers should initialize state
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (error) {
    return undefined;
  }
};

export const saveState = state => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem("state", serializedState);
  } catch (error) {
    // Ignore write errors
  }
};



// WEBPACK FOOTER //
// ./src/utils/localstorage.js